import React from 'react';
import Stepper from 'react-stepper-horizontal';
import { useNavigate } from 'react-router-dom';

import UttamKalakarFooter from './UttamKalakarFooter';

// Removed Step 1
const steps = [
    { title: 'Upload Articles', route: '/articleupload', color: 'blue' },
    { title: 'Upload Images', route: '/articleimageupload', color: 'blue' },
];

const ManuScriptSteps = () => {
    const navigate = useNavigate();

    const handleButtonClick = (route) => {
        navigate(route);
    };

    return (
        <div style={{ paddingTop: 200 }}>
            <Stepper
                steps={steps}
                activeStep={steps.length - 1} // Now points to last step (Upload Images)
                circleFontSize={16}
                defaultTitleColor="black"
                circleTop={0}
                circleLeft={0}
            />

            <div
                className="button-container"
                style={{
                    marginTop: '60px',
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center'
                }}
            >
                {steps.map((step, index) => (
                    <button
                        key={index}
                        className={`btn btn-primary btn-lg ${
                            step.color === 'blue' ? 'btn-blue' : 'btn-green'
                        }`}
                        style={{
                            margin: '5px',
                            padding: '20px 20px',
                            width: '300px',
                            fontWeight: 'bold',
                        }}
                        onClick={() => handleButtonClick(step.route)}
                    >
                        {step.title}
                    </button>
                ))}
            </div>

            <div style={{ padding: 60 }}></div>

            <UttamKalakarFooter />
        </div>
    );
};

export default ManuScriptSteps;